import React, { useState } from 'react'
import styled from "styled-components"
import { tenantCashFlow, Params } from 'data/reporting/tenant-cash-flow'
import { RentRollCalcData } from 'data/calc'
import { ReactGrid } from "@silevis/reactgrid"
import "@silevis/reactgrid/styles.css"

type Periodicity = "Lease Year" | "Calendar Year" | "Monthly"

const RadioSwitcher: React.FC<{ selectedValue: Periodicity, onChange: (value: Periodicity) => void }> = ({ selectedValue, onChange }) => {

  const handleChange = (event) => {
    onChange(event.target.value) // Call the parent’s onChange function
  }

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      <label>Periodicity:</label>
      <label><input type="radio" value="Monthly" checked={selectedValue === "Monthly"} onChange={handleChange} /> Monthly </label>
      <label><input type="radio" value="Lease Year" checked={selectedValue === "Lease Year"} onChange={handleChange} /> Annual (Lease Year) </label>
      <label><input type="radio" value="Calendar Year" checked={selectedValue === "Calendar Year"} onChange={handleChange} /> Annual (Calendar Year) </label>
    </div>
  )
}

const rx = /(\d\d\d\d)\-(\d\d)\-(\d\d)/

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-right: 10px;
`

const FixedHeader = styled.div`
  flex-shrink: 0;
  margin-bottom: 6px;
`

const ScrollableGridContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`
const monthOf = (date: string) => (date.substring(5, 7))
const yearOf = (date: string) => (date.substring(0, 4))
export const TenantCashFlow: React.FC<{ dataBeginDate: string, dataEndDate: string, data: RentRollCalcData }> = ({ dataBeginDate, dataEndDate, data }) => {

  const [periodicity, setPeriodicity] = useState("Lease Year" as Periodicity)
  const leaseBegin = data.leaseInterval.begin;
  const leaseEnd = data.leaseInterval.end;


  const beginDate = (() => {
    const beginDateDay = dataBeginDate < leaseBegin ? leaseBegin : dataBeginDate
    if (periodicity == "Calendar Year")
      return `${yearOf(beginDateDay)}-01-01`
    else if (periodicity == "Monthly")
      return `${yearOf(beginDateDay)}-${monthOf(beginDateDay)}-01`
    else 
      return `${yearOf(leaseBegin)}-${monthOf(leaseBegin)}-01`
  })()
  const endDate = dataEndDate

  const params: Params = { beginDate, endDate, periodicity: periodicity == "Monthly" ? 1 : 12 }

  const content = tenantCashFlow(params, dataBeginDate, data)
  const { css, props: { rows, columns, stickyTopRows, stickyLeftColumns } } = content

  const Parent = styled.div`${css}`

  return (
    <Container>
      <FixedHeader>
        <RadioSwitcher selectedValue={periodicity} onChange={setPeriodicity} />
      </FixedHeader>
      <ScrollableGridContainer>
        <Parent>
          <ReactGrid
            rows={rows}
            columns={columns}
            stickyTopRows={stickyTopRows}
            stickyLeftColumns={stickyLeftColumns}
            minColumnWidth={0}
            enableFillHandle
            enableRangeSelection
          />
        </Parent>
      </ScrollableGridContainer>
    </Container>
  )
}
